import type { ResponseAvailableFilter } from "@/utils/types/filter";

export const useFilterStore = defineStore("filter-store", () => {
  const filters = ref<ResponseAvailableFilter>();

  const getAvailableFilters = async () => {
    return await useApi<ResponseAvailableFilter>(
      `/v1/catalog/available-filters/`,
      {
        method: "get",
      },
      {
        bypassAbort: true,
      },
    );
  };

  return {
    filters,

    getAvailableFilters,
  };
});
